import React from 'react'
import "./AboutUs.css"
import { Link } from 'react-router-dom';
import HomePage from '../HomePage/HomePage';
import Footer from '../Footer/Footer';
import Nav from '../NavBar/Nav';
import puppy from "../../assets/images/puppy.jpg"
import pupps from "../../assets/images/pupps.jpg";

function AboutUs() {
	return (
		<>
			<Nav />
			<div className="row__title col-12">
				<h2>Get involved</h2>
			</div>
			<br />
			<HomePage
				title="Welcome to Our Store"
				image={pupps}
				altText="Product Image"
				productTitle="Our story"
				productDescription="Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
			/>
			<br />
			<HomePage
				title="Welcome to Our Store"
				image="https://images.unsplash.com/photo-1593134257782-e89567b7718a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=735&q=80"
				altText="Product Image"
				productTitle="Our story"
				productDescription="Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
				productDescription2="Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
				isReverse={true} // Set this to true for the second row
			/>
			<br />
			<HomePage
				title="Welcome to Our Store"
				image="https://images.unsplash.com/photo-1589441161120-8781d5644435?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1025&q=80"
				altText="Product Image"
				productTitle="Our story"
				productDescription="Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. Quis aute iure reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
			/>
			<br />
			<HomePage
				title="Welcome to Our Store"
				image={puppy}
				altText="Product Image"
				productTitle="Our story"
				productDescription="Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur. "
			/>
			<br />
			<Footer />
		</>
	);
}

export default AboutUs;

